import { render } from "./LeadsInformation.vue?vue&type=template&id=afe11e40"
import script from "./LeadsInformation.vue?vue&type=script&lang=js"
export * from "./LeadsInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__